<template>
    <div class="user-modal-body">
        <h3 class="text-center mb-4">{{$t('message.spots.message.vpnRegistration')}}</h3>

        <v-flex xs12 text-xs-center style="margin-bottom: 10px;">
            <v-flex xs5>
                <div class="select-description">
                    {{$t('message.spots.message.vpnAuth')}}
                </div>
                <app-select v-model="vpn.auth"
                            :data-title="$t('message.spots.message.select')"
                            :data-search="false"
                            :data-items="authtypes"
                            :clearable="false"/>
            </v-flex>
            <v-flex xs5>
                <div class="select-description">
                    {{$t('message.spots.message.vpnCypher')}}
                </div>
                <app-select v-model="vpn.cipher"
                            :data-title="$t('message.spots.message.select')"
                            :data-search="false"
                            :data-items="ciphertypes"
                            :clearable="false"/>
            </v-flex>
        </v-flex>
        <v-flex xs12 text-xs-center>
            <v-flex xs5>
                <v-text-field v-model="vpn.name"
                              type="text"
                              :label="$t('message.generics.message.name')"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field v-model="vpn.serverApiPort"
                              type="number"
                              :label="$t('message.spots.message.serverApiPort')"></v-text-field>
            </v-flex>
        </v-flex>

        <v-flex xs12 text-xs-center>
            <v-flex xs5>
                <v-text-field v-model="vpn.serverAddress"
                              type="text"
                              :label="$t('message.spots.message.serverAddress')"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field v-model="vpn.serverApiLogin"
                              type="text"
                              :label="$t('message.spots.message.serverApiLogin')"></v-text-field>
            </v-flex>
        </v-flex>

        <v-flex xs12 text-xs-center>
            <v-flex xs5>
                <v-text-field v-model="vpn.serverVpnPort"
                              type="number"
                              :label="$t('message.spots.message.serverVpnPort')"></v-text-field>
            </v-flex>
            <v-flex xs5>
                <v-text-field v-model="vpn.serverApiPassword"
                              type="text"
                              :label="$t('message.spots.message.serverApiPassword')"></v-text-field>
            </v-flex>
        </v-flex>
        <div class="card-footer">
            <div class="footer flex-center mt-2">
                <button class="btn btn-primary btn-round" @click="submit()">
                    {{$t('message.generics.message.save')}}
                </button>
            </div>
        </div>


    </div>
</template>

<script>
    import AppSelect from '@components/Select'
    import EventBus from '@packages/event-bus'

    export default {
        components: {
            AppSelect
        },

        data() {
            return {
                vpn:{},
                authtypes:[
                    {id: 'SHA1', label: 'SHA1'},
                    {id: 'MD5', label: 'MD5'}
                ],
                ciphertypes:[
                    {id: 'BLOWFISH128', label: 'BLOWFISH128'},
                    {id: 'AES128', label: 'AES128'},
                    {id: 'AES192', label: 'AES192'},
                    {id: 'AES256', label: 'AES256'}
                ]
            }
        },


        methods: {
            reset(vpn) {
                if (vpn){
                    this.vpn = vpn
                } else {
                    this.vpn = {};
                }
            },

            async submit() {
                if (this.vpn.id) {
                    await this.$api.connectionsupport.update(this.vpn)
                } else {
                    await this.$api.connectionsupport.create(this.vpn)
                }
                EventBus.$emit('RESET_VPN_SUPPORT')
            },

        },


        mounted() {
            EventBus.$on('RESET_BODY_VPN_SUPPORT', this.reset)
        },

        beforeDestroy() {
            EventBus.$off('RESET_BODY_VPN_SUPPORT', this.reset)
        },

    }
</script>

<style lang="scss" scoped>
    .user-modal-body {
        padding: 30px 50px;

        .flex {
            justify-content: space-between;
        }

        .select-description{
            padding-top: 6px;
            width: 100px;
        }
        .dropdown{
            width: calc(100% - 100px) !important;
        }
    }
</style>
